import type { Scene } from '../scenes';

const park: Scene = {
  id: 'park',
  label: 'Park',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="150" fill="#e3eef5" />
      <rect y="150" width="400" height="150" fill="#cfe0b8" />
      <path d="M0 214 Q120 200 200 222 Q280 244 400 206 L400 218 Q280 258 200 236 Q120 214 0 228 Z" fill="#e6d9bf" />
    </>
  ),
  parts: [
    {
      id: 'tree', label: 'tree', at: [48, 120], box: [6, 50, 86, 154], art: (
        <g>
          <rect x="40" y="120" width="16" height="80" rx="3" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
          <circle cx="48" cy="94" r="40" fill="#8fbf7a" stroke="#6a9a58" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'bench', label: 'bench', at: [150, 186], box: [104, 160, 92, 48], art: (
        <g fill="#b98a5c" stroke="#8a643f" strokeWidth="2">
          <rect x="110" y="166" width="80" height="8" rx="2" />
          <rect x="110" y="178" width="80" height="8" rx="2" />
          <rect x="108" y="190" width="84" height="7" rx="2" />
          <rect x="116" y="197" width="6" height="9" />
          <rect x="178" y="197" width="6" height="9" />
        </g>
      ),
    },
    {
      id: 'bin', label: 'bin', at: [222, 180], box: [204, 154, 36, 52], art: (
        <g>
          <rect x="211" y="166" width="22" height="38" rx="3" fill="#7fa08a" stroke="#5c7a66" strokeWidth="2" />
          <rect x="208" y="160" width="28" height="7" rx="2" fill="#5c7a66" />
        </g>
      ),
    },
    {
      id: 'pond', label: 'pond', at: [290, 254], box: [206, 222, 168, 66], art: (
        <ellipse cx="290" cy="256" rx="80" ry="30" fill="#a9cde3" stroke="#7aa9c6" strokeWidth="3" />
      ),
    },
    {
      id: 'duck', label: 'duck', at: [268, 250], box: [248, 234, 42, 30], art: (
        <g>
          <path d="M254 254 Q256 262 270 262 Q284 262 284 252 Q276 254 270 250 Z" fill="#f4f1e8" stroke="#b8b2a4" strokeWidth="2" />
          <circle cx="258" cy="246" r="6" fill="#f4f1e8" stroke="#b8b2a4" strokeWidth="2" />
          <path d="M252 246 L246 248 L252 249 Z" fill="#e0a64a" />
          <circle cx="257" cy="245" r="1.5" fill="#3a3a3a" />
        </g>
      ),
    },
    {
      id: 'lamp', label: 'lamp post', at: [366, 130], box: [348, 62, 36, 138], art: (
        <g>
          <rect x="363" y="80" width="6" height="116" fill="#5c6670" />
          <rect x="358" y="192" width="16" height="6" rx="2" fill="#5c6670" />
          <path d="M356 82 L376 82 L372 66 L360 66 Z" fill="#f2df9a" stroke="#5c6670" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'sun', label: 'sun', at: [320, 38], box: [294, 12, 52, 52], art: (
        <circle cx="320" cy="38" r="20" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'cloud', label: 'cloud', at: [180, 45], box: [140, 26, 80, 38], art: (
        <g fill="#ffffff" stroke="#c9d6df" strokeWidth="2">
          <path d="M150 58 Q142 46 156 42 Q160 30 176 34 Q186 26 198 36 Q214 36 210 50 Q214 60 200 60 L158 60 Q148 60 150 58 Z" />
        </g>
      ),
    },
    {
      id: 'kite', label: 'kite', at: [250, 64], box: [228, 34, 44, 58], art: (
        <g>
          <polygon points="250,38 266,58 250,80 234,58" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <line x1="250" y1="38" x2="250" y2="80" stroke="#b0685a" strokeWidth="1.5" />
          <line x1="234" y1="58" x2="266" y2="58" stroke="#b0685a" strokeWidth="1.5" />
          <path d="M250 80 Q246 86 252 90 Q256 94 252 100" fill="none" stroke="#8a7a6a" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'bird', label: 'bird', at: [104, 24], box: [86, 10, 36, 28], art: (
        <path d="M90 26 Q97 16 104 24 Q111 16 118 26" fill="none" stroke="#5c6670" strokeWidth="3" strokeLinecap="round" />
      ),
    },
    {
      id: 'dog', label: 'dog', at: [120, 262], box: [90, 238, 62, 42], art: (
        <g fill="#c89a6a" stroke="#9a7452" strokeWidth="2">
          <rect x="100" y="252" width="40" height="16" rx="7" />
          <rect x="104" y="266" width="6" height="12" rx="2" />
          <rect x="130" y="266" width="6" height="12" rx="2" />
          <circle cx="142" cy="250" r="9" />
          <path d="M136 244 L134 254 L140 250 Z" fill="#9a7452" />
          <path d="M100 256 L94 246" fill="none" strokeWidth="4" strokeLinecap="round" />
          <circle cx="145" cy="248" r="1.5" fill="#3a3a3a" stroke="none" />
        </g>
      ),
    },
    {
      id: 'flowers', label: 'flowers', at: [40, 256], box: [12, 232, 60, 50], art: (
        <g>
          <g stroke="#6a9a58" strokeWidth="3">
            <line x1="24" y1="252" x2="24" y2="276" />
            <line x1="42" y1="246" x2="42" y2="276" />
            <line x1="60" y1="254" x2="60" y2="276" />
          </g>
          <circle cx="24" cy="250" r="7" fill="#e3a3b5" stroke="#c07a8e" strokeWidth="2" />
          <circle cx="42" cy="242" r="7" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
          <circle cx="60" cy="252" r="7" fill="#b9a6d9" stroke="#8e7ab8" strokeWidth="2" />
        </g>
      ),
    },
  ],
};

const playground: Scene = {
  id: 'playground',
  label: 'Playground',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="140" fill="#e3eef5" />
      <rect y="140" width="400" height="160" fill="#cfe0b8" />
    </>
  ),
  parts: [
    {
      id: 'swing', label: 'swing', at: [70, 140], box: [12, 82, 116, 124], art: (
        <g>
          <g stroke="#b0685a" strokeWidth="5" strokeLinecap="round">
            <line x1="30" y1="90" x2="18" y2="200" />
            <line x1="30" y1="90" x2="42" y2="200" />
            <line x1="110" y1="90" x2="98" y2="200" />
            <line x1="110" y1="90" x2="122" y2="200" />
            <line x1="26" y1="90" x2="114" y2="90" />
          </g>
          <g stroke="#7f8b96" strokeWidth="2">
            <line x1="58" y1="92" x2="58" y2="170" />
            <line x1="82" y1="92" x2="82" y2="170" />
          </g>
          <rect x="54" y="168" width="32" height="7" rx="2" fill="#5c7a96" />
        </g>
      ),
    },
    {
      id: 'slide', label: 'slide', at: [200, 150], box: [140, 98, 120, 106], art: (
        <g>
          <g stroke="#8a96a3" strokeWidth="4">
            <line x1="152" y1="108" x2="152" y2="200" />
            <line x1="172" y1="108" x2="172" y2="200" />
          </g>
          <g stroke="#8a96a3" strokeWidth="3">
            {[124, 142, 160, 178, 196].map((y) => <line key={y} x1="152" y1={y} x2="172" y2={y} />)}
          </g>
          <rect x="148" y="104" width="30" height="8" rx="2" fill="#8a96a3" />
          <path d="M176 106 L182 106 Q214 170 252 192 L252 200 L240 200 Q206 176 176 116 Z" fill="#e0b34a" stroke="#b88f30" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'frame', label: 'climbing frame', at: [330, 162], box: [282, 112, 96, 102], art: (
        <g fill="none" stroke="#5c8a6a" strokeWidth="4" strokeLinecap="round">
          {[290, 316, 342, 368].map((x) => <line key={x} x1={x} y1="120" x2={x} y2="208" />)}
          {[120, 149, 178].map((y) => <line key={y} x1="290" y1={y} x2="368" y2={y} />)}
        </g>
      ),
    },
    {
      id: 'seesaw', label: 'seesaw', at: [322, 262], box: [266, 238, 112, 44], art: (
        <g>
          <polygon points="322,262 308,280 336,280" fill="#7f8b96" stroke="#5c6670" strokeWidth="2" />
          <path d="M272 268 L372 246 L374 254 L274 276 Z" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <rect x="282" y="258" width="4" height="12" fill="#5c6670" transform="rotate(-12 284 264)" />
          <rect x="356" y="242" width="4" height="12" fill="#5c6670" transform="rotate(-12 358 248)" />
        </g>
      ),
    },
    {
      id: 'roundabout', label: 'roundabout', at: [80, 258], box: [30, 230, 100, 54], art: (
        <g>
          <ellipse cx="80" cy="266" rx="44" ry="12" fill="#5c7a96" stroke="#41607a" strokeWidth="2" />
          <ellipse cx="80" cy="262" rx="44" ry="12" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <line x1="80" y1="262" x2="80" y2="240" stroke="#41607a" strokeWidth="4" />
          <path d="M50 258 L50 244 L110 244 L110 258" fill="none" stroke="#41607a" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'sandpit', label: 'sandpit', at: [214, 262], box: [158, 234, 104, 54], art: (
        <g>
          <rect x="164" y="240" width="92" height="44" rx="4" fill="#ead7a8" stroke="#a8713f" strokeWidth="5" />
        </g>
      ),
    },
    {
      id: 'bucket', label: 'bucket', at: [196, 260], box: [178, 244, 36, 34], art: (
        <g>
          <path d="M186 254 L206 254 L203 274 L189 274 Z" fill="#d8473b" stroke="#a83a31" strokeWidth="2" />
          <path d="M186 254 Q196 242 206 254" fill="none" stroke="#a83a31" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'ball', label: 'ball', at: [136, 220], box: [118, 202, 36, 34], art: (
        <g>
          <circle cx="136" cy="220" r="13" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <path d="M124 216 Q136 224 148 216" fill="none" stroke="#f4f1e8" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'tree', label: 'tree', at: [364, 66], box: [330, 20, 68, 92], art: (
        <g>
          <rect x="358" y="70" width="12" height="40" rx="3" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
          <circle cx="364" cy="54" r="30" fill="#8fbf7a" stroke="#6a9a58" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'sun', label: 'sun', at: [40, 40], box: [14, 14, 52, 52], art: (
        <circle cx="40" cy="40" r="20" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'cloud', label: 'cloud', at: [190, 45], box: [150, 26, 80, 38], art: (
        <path d="M160 58 Q152 46 166 42 Q170 30 186 34 Q196 26 208 36 Q224 36 220 50 Q224 60 210 60 L168 60 Q158 60 160 58 Z" fill="#ffffff" stroke="#c9d6df" strokeWidth="2" />
      ),
    },
    {
      id: 'bird', label: 'bird', at: [282, 50], box: [264, 36, 36, 28], art: (
        <path d="M268 52 Q275 42 282 50 Q289 42 296 52" fill="none" stroke="#5c6670" strokeWidth="3" strokeLinecap="round" />
      ),
    },
  ],
};

const beach: Scene = {
  id: 'beach',
  label: 'Beach',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="114" fill="#e3eef5" />
      <rect y="166" width="400" height="134" fill="#efe0bc" />
    </>
  ),
  parts: [
    {
      id: 'sea', label: 'sea', at: [200, 140], box: [0, 114, 400, 52], art: (
        <g>
          <rect y="114" width="400" height="54" fill="#a9cde3" />
          <path d="M0 168 Q20 160 40 168 Q60 160 80 168 Q100 160 120 168 Q140 160 160 168 Q180 160 200 168 Q220 160 240 168 Q260 160 280 168 Q300 160 320 168 Q340 160 360 168 Q380 160 400 168" fill="none" stroke="#7aa9c6" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'boat', label: 'boat', at: [96, 116], box: [56, 66, 82, 84], art: (
        <g>
          <line x1="96" y1="72" x2="96" y2="132" stroke="#7a5a3e" strokeWidth="3" />
          <polygon points="99,74 99,128 130,128" fill="#f4f1e8" stroke="#b8b2a4" strokeWidth="2" />
          <polygon points="93,82 93,128 70,128" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <path d="M62 132 L134 132 L124 146 L72 146 Z" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'sun', label: 'sun', at: [340, 44], box: [314, 18, 52, 52], art: (
        <circle cx="340" cy="44" r="22" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'seagull', label: 'seagull', at: [230, 52], box: [208, 38, 44, 28], art: (
        <path d="M212 54 Q221 42 230 52 Q239 42 248 54" fill="none" stroke="#5c6670" strokeWidth="3" strokeLinecap="round" />
      ),
    },
    {
      id: 'umbrella', label: 'umbrella', at: [300, 196], box: [252, 146, 96, 98], art: (
        <g>
          <line x1="300" y1="160" x2="300" y2="240" stroke="#7a5a3e" strokeWidth="4" />
          <path d="M256 180 Q260 150 300 150 Q340 150 344 180 Z" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <path d="M286 180 Q290 152 300 150 Q310 152 314 180" fill="#f4f1e8" stroke="#b0685a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'towel', label: 'towel', at: [300, 264], box: [244, 248, 112, 34], art: (
        <g>
          <rect x="250" y="252" width="100" height="24" rx="2" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <rect x="250" y="260" width="100" height="7" fill="#f4f1e8" />
        </g>
      ),
    },
    {
      id: 'ball', label: 'ball', at: [210, 214], box: [192, 196, 36, 36], art: (
        <g>
          <circle cx="210" cy="214" r="14" fill="#f4f1e8" stroke="#b8b2a4" strokeWidth="2" />
          <path d="M210 200 Q200 214 210 228" fill="#d8473b" />
          <path d="M210 200 Q220 214 210 228" fill="#2f74c8" />
          <circle cx="210" cy="214" r="14" fill="none" stroke="#8a8478" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'sandcastle', label: 'sandcastle', at: [80, 226], box: [36, 188, 90, 66], art: (
        <g fill="#dcc48e" stroke="#a88a52" strokeWidth="2">
          <path d="M44 248 L44 218 L116 218 L116 248 Z" />
          <path d="M62 218 L62 196 L68 196 L68 202 L74 202 L74 196 L80 196 L80 202 L86 202 L86 196 L92 196 L92 202 L98 202 L98 196 L98 218 Z" />
          <rect x="72" y="230" width="16" height="18" rx="7" fill="#a88a52" />
          <line x1="80" y1="196" x2="80" y2="184" stroke="#7a5a3e" />
          <polygon points="81,184 92,188 81,192" fill="#d98a7a" stroke="#b0685a" strokeWidth="1" />
        </g>
      ),
    },
    {
      id: 'bucket', label: 'bucket', at: [152, 252], box: [132, 232, 38, 40], art: (
        <g>
          <path d="M140 244 L164 244 L160 268 L144 268 Z" fill="#2f74c8" stroke="#22558f" strokeWidth="2" />
          <path d="M140 244 Q152 228 164 244" fill="none" stroke="#22558f" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'spade', label: 'spade', at: [190, 266], box: [174, 240, 34, 54], art: (
        <g>
          <line x1="190" y1="244" x2="190" y2="272" stroke="#d8473b" strokeWidth="4" strokeLinecap="round" />
          <rect x="183" y="242" width="14" height="5" rx="2" fill="#d8473b" />
          <path d="M181 272 L199 272 L197 286 Q190 292 183 286 Z" fill="#f2c230" stroke="#c49a20" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'crab', label: 'crab', at: [374, 222], box: [350, 204, 46, 34], art: (
        <g fill="#d8473b" stroke="#a83a31" strokeWidth="2">
          <ellipse cx="374" cy="224" rx="12" ry="8" />
          <path d="M362 220 Q354 214 358 208" fill="none" strokeWidth="3" />
          <path d="M386 220 Q394 214 390 208" fill="none" strokeWidth="3" />
          <circle cx="358" cy="208" r="3" />
          <circle cx="390" cy="208" r="3" />
          <path d="M364 228 L356 234 M368 230 L362 236 M384 228 L392 234 M380 230 L386 236" fill="none" />
          <circle cx="370" cy="220" r="1.5" fill="#3a3a3a" stroke="none" />
          <circle cx="378" cy="220" r="1.5" fill="#3a3a3a" stroke="none" />
        </g>
      ),
    },
    {
      id: 'shell', label: 'shell', at: [32, 278], box: [14, 262, 38, 30], art: (
        <g>
          <path d="M20 284 Q20 266 32 266 Q44 266 44 284 Z" fill="#e3a3b5" stroke="#c07a8e" strokeWidth="2" />
          <g stroke="#c07a8e" strokeWidth="1.5">
            <line x1="32" y1="284" x2="32" y2="268" />
            <line x1="32" y1="284" x2="25" y2="270" />
            <line x1="32" y1="284" x2="39" y2="270" />
          </g>
        </g>
      ),
    },
  ],
};

const farm: Scene = {
  id: 'farm',
  label: 'Farm',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="130" fill="#e3eef5" />
      <path d="M0 130 Q100 110 200 124 Q300 138 400 118 L400 300 L0 300 Z" fill="#cfe0b8" />
      <path d="M0 196 Q200 186 400 200 L400 300 L0 300 Z" fill="#c4d8aa" />
    </>
  ),
  parts: [
    {
      id: 'barn', label: 'barn', at: [74, 120], box: [12, 52, 124, 124], art: (
        <g>
          <polygon points="18,104 74,58 130,104" fill="#a8574c" stroke="#80423a" strokeWidth="3" />
          <rect x="24" y="104" width="100" height="68" fill="#c06a5c" stroke="#80423a" strokeWidth="3" />
          <rect x="54" y="122" width="40" height="50" fill="#f4ece0" stroke="#80423a" strokeWidth="3" />
          <line x1="54" y1="122" x2="94" y2="172" stroke="#80423a" strokeWidth="3" />
          <line x1="94" y1="122" x2="54" y2="172" stroke="#80423a" strokeWidth="3" />
          <rect x="66" y="82" width="16" height="14" fill="#f4ece0" stroke="#80423a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'fence', label: 'fence', at: [272, 126], box: [148, 108, 250, 34], art: (
        <g fill="#c9a87e" stroke="#9a7a52" strokeWidth="2">
          <rect x="150" y="118" width="246" height="6" />
          <rect x="150" y="130" width="246" height="6" />
          {[154, 194, 234, 274, 314, 354, 390].map((x) => <rect key={x} x={x - 3} y="112" width="7" height="28" rx="1" />)}
        </g>
      ),
    },
    {
      id: 'tree', label: 'tree', at: [190, 60], box: [154, 22, 72, 86], art: (
        <g>
          <rect x="184" y="76" width="12" height="38" rx="3" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
          <circle cx="190" cy="58" r="32" fill="#8fbf7a" stroke="#6a9a58" strokeWidth="3" />
        </g>
      ),
    },
    {
      id: 'cloud', label: 'cloud', at: [290, 42], box: [252, 22, 76, 40], art: (
        <path d="M262 56 Q254 44 268 40 Q272 28 288 32 Q298 24 310 34 Q326 34 322 48 Q326 58 312 58 L270 58 Q260 58 262 56 Z" fill="#ffffff" stroke="#c9d6df" strokeWidth="2" />
      ),
    },
    {
      id: 'sun', label: 'sun', at: [366, 40], box: [340, 14, 52, 52], art: (
        <circle cx="366" cy="40" r="20" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'tractor', label: 'tractor', at: [206, 176], box: [160, 144, 96, 62], art: (
        <g>
          <rect x="170" y="166" width="70" height="20" rx="3" fill="#5c9a5c" stroke="#3f7a3f" strokeWidth="2" />
          <path d="M196 166 L196 148 L230 148 L234 166 Z" fill="#cfe8f7" stroke="#3f7a3f" strokeWidth="3" />
          <rect x="238" y="156" width="5" height="12" fill="#5c6670" />
          <circle cx="188" cy="186" r="16" fill="#4a4a4a" stroke="#2e2e2e" strokeWidth="2" />
          <circle cx="188" cy="186" r="6" fill="#e0b34a" />
          <circle cx="238" cy="194" r="9" fill="#4a4a4a" stroke="#2e2e2e" strokeWidth="2" />
          <circle cx="238" cy="194" r="3" fill="#e0b34a" />
        </g>
      ),
    },
    {
      id: 'cow', label: 'cow', at: [330, 182], box: [290, 150, 102, 60], art: (
        <g>
          <rect x="304" y="164" width="58" height="28" rx="8" fill="#f4f1e8" stroke="#8a8478" strokeWidth="2" />
          <path d="M318 166 Q330 170 326 182 Q314 184 312 172 Z" fill="#4a4a4a" />
          <path d="M342 176 Q352 172 354 184 Q346 190 340 184 Z" fill="#4a4a4a" />
          <g fill="#f4f1e8" stroke="#8a8478" strokeWidth="2">
            <rect x="308" y="190" width="7" height="16" />
            <rect x="350" y="190" width="7" height="16" />
            <rect x="364" y="156" width="20" height="22" rx="7" />
          </g>
          <ellipse cx="376" cy="176" rx="9" ry="5" fill="#e3b8b0" stroke="#b08a82" strokeWidth="1.5" />
          <path d="M366 158 L362 152 M382 158 L386 152" stroke="#8a8478" strokeWidth="3" strokeLinecap="round" />
          <circle cx="370" cy="164" r="1.8" fill="#3a3a3a" />
          <path d="M304 170 L296 184" stroke="#8a8478" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'gate', label: 'gate', at: [56, 240], box: [12, 210, 96, 64], art: (
        <g fill="#c9a87e" stroke="#9a7a52" strokeWidth="2">
          <rect x="16" y="214" width="8" height="56" />
          <rect x="94" y="214" width="8" height="56" />
          <rect x="24" y="220" width="70" height="6" />
          <rect x="24" y="236" width="70" height="6" />
          <rect x="24" y="252" width="70" height="6" />
          <path d="M26 256 L92 222 L92 228 L28 260 Z" />
        </g>
      ),
    },
    {
      id: 'hen', label: 'hen', at: [158, 248], box: [134, 226, 46, 46], art: (
        <g>
          <path d="M140 246 Q140 264 158 264 Q174 264 172 246 Q166 252 160 248 Q156 238 148 240 Z" fill="#b9805a" stroke="#8a5a3e" strokeWidth="2" />
          <circle cx="166" cy="240" r="7" fill="#b9805a" stroke="#8a5a3e" strokeWidth="2" />
          <path d="M163 232 L166 228 L169 232" fill="#d8473b" stroke="#a83a31" strokeWidth="1.5" />
          <path d="M173 239 L179 241 L173 243 Z" fill="#e0a64a" />
          <circle cx="168" cy="239" r="1.5" fill="#3a3a3a" />
          <path d="M154 264 L152 270 M162 264 L164 270" stroke="#e0a64a" strokeWidth="2" />
          <path d="M140 246 L134 236 L142 240" fill="#8a5a3e" />
        </g>
      ),
    },
    {
      id: 'sheep', label: 'sheep', at: [234, 256], box: [196, 232, 72, 46], art: (
        <g>
          <g fill="#4a4a4a">
            <rect x="214" y="262" width="5" height="12" />
            <rect x="242" y="262" width="5" height="12" />
          </g>
          <path d="M206 254 Q204 240 216 240 Q222 232 232 238 Q242 232 248 240 Q258 242 254 254 Q258 266 244 266 L216 266 Q204 266 206 254 Z" fill="#f4f1e8" stroke="#b8b2a4" strokeWidth="2" />
          <ellipse cx="258" cy="248" rx="7" ry="9" fill="#4a4a4a" />
          <circle cx="260" cy="246" r="1.5" fill="#f4f1e8" />
        </g>
      ),
    },
    {
      id: 'pig', label: 'pig', at: [334, 258], box: [294, 234, 82, 48], art: (
        <g fill="#e8b4b0" stroke="#b8807a" strokeWidth="2">
          <rect x="306" y="262" width="7" height="14" />
          <rect x="342" y="262" width="7" height="14" />
          <ellipse cx="328" cy="256" rx="28" ry="15" />
          <circle cx="358" cy="252" r="11" />
          <ellipse cx="368" cy="254" rx="5" ry="6" />
          <path d="M354 242 L358 236 L362 243" />
          <circle cx="360" cy="248" r="1.5" fill="#3a3a3a" stroke="none" />
          <path d="M300 252 Q294 248 298 244" fill="none" />
        </g>
      ),
    },
  ],
};

const garden: Scene = {
  id: 'garden',
  label: 'Garden',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="120" fill="#e3eef5" />
      <rect y="120" width="400" height="180" fill="#cfe0b8" />
      <g fill="#e2d2b4" stroke="#c9b48f" strokeWidth="1.5">
        {Array.from({ length: 20 }, (_, i) => <rect key={i} x={i * 20 + 1} y="90" width="18" height="34" />)}
      </g>
      <path d="M120 300 Q150 230 210 200 L240 200 Q190 240 170 300 Z" fill="#e6d9bf" />
    </>
  ),
  parts: [
    {
      id: 'tree', label: 'tree', at: [60, 80], box: [16, 24, 90, 138], art: (
        <g>
          <rect x="52" y="90" width="16" height="70" rx="3" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
          <circle cx="60" cy="68" r="40" fill="#8fbf7a" stroke="#6a9a58" strokeWidth="3" />
          <circle cx="44" cy="62" r="5" fill="#d8473b" />
          <circle cx="72" cy="54" r="5" fill="#d8473b" />
          <circle cx="66" cy="84" r="5" fill="#d8473b" />
        </g>
      ),
    },
    {
      id: 'shed', label: 'shed', at: [330, 116], box: [274, 50, 114, 126], art: (
        <g>
          <polygon points="276,92 330,56 384,92" fill="#8a7a6a" stroke="#6a5c4e" strokeWidth="3" />
          <rect x="284" y="92" width="92" height="80" fill="#a8c0a0" stroke="#6f8a68" strokeWidth="3" />
          <rect x="300" y="110" width="28" height="62" fill="#8fa888" stroke="#6f8a68" strokeWidth="2" />
          <circle cx="322" cy="142" r="2.5" fill="#4a4a4a" />
          <rect x="342" y="108" width="24" height="20" fill="#cfe8f7" stroke="#6f8a68" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'sun', label: 'sun', at: [220, 36], box: [194, 10, 52, 52], art: (
        <circle cx="220" cy="36" r="20" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'bird', label: 'bird', at: [150, 40], box: [128, 24, 46, 32], art: (
        <g>
          <ellipse cx="148" cy="42" rx="12" ry="8" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <circle cx="160" cy="36" r="6" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <path d="M165 35 L171 37 L165 39 Z" fill="#e0a64a" />
          <circle cx="161" cy="35" r="1.3" fill="#3a3a3a" />
          <path d="M136 40 L130 36 L132 44 Z" fill="#41607a" />
          <path d="M146 40 Q150 46 156 42" fill="none" stroke="#41607a" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'flowers', label: 'flowers', at: [64, 200], box: [22, 168, 88, 62], art: (
        <g>
          <g stroke="#6a9a58" strokeWidth="3">
            <line x1="36" y1="196" x2="36" y2="226" />
            <line x1="64" y1="186" x2="64" y2="226" />
            <line x1="92" y1="198" x2="92" y2="226" />
          </g>
          <ellipse cx="50" cy="214" rx="8" ry="4" fill="#8fbf7a" transform="rotate(-30 50 214)" />
          <ellipse cx="78" cy="212" rx="8" ry="4" fill="#8fbf7a" transform="rotate(30 78 212)" />
          <g fill="#e3a3b5" stroke="#c07a8e" strokeWidth="1.5">
            {[0, 72, 144, 216, 288].map((a) => <circle key={a} cx={36 + 7 * Math.cos((a * Math.PI) / 180)} cy={190 + 7 * Math.sin((a * Math.PI) / 180)} r="5" />)}
          </g>
          <g fill="#b9a6d9" stroke="#8e7ab8" strokeWidth="1.5">
            {[0, 72, 144, 216, 288].map((a) => <circle key={a} cx={64 + 7 * Math.cos((a * Math.PI) / 180)} cy={180 + 7 * Math.sin((a * Math.PI) / 180)} r="5" />)}
          </g>
          <g fill="#f2d27a" stroke="#d9b354" strokeWidth="1.5">
            {[0, 72, 144, 216, 288].map((a) => <circle key={a} cx={92 + 7 * Math.cos((a * Math.PI) / 180)} cy={192 + 7 * Math.sin((a * Math.PI) / 180)} r="5" />)}
          </g>
          <circle cx="36" cy="190" r="4" fill="#e0b34a" />
          <circle cx="64" cy="180" r="4" fill="#e0b34a" />
          <circle cx="92" cy="192" r="4" fill="#d98a7a" />
        </g>
      ),
    },
    {
      id: 'pot', label: 'plant pot', at: [222, 158], box: [200, 130, 44, 50], art: (
        <g>
          <path d="M210 160 Q206 140 216 138 Q218 148 222 152 Q224 136 232 134 Q238 146 232 160 Z" fill="#8fbf7a" stroke="#6a9a58" strokeWidth="2" />
          <path d="M206 158 L238 158 L234 178 L210 178 Z" fill="#c9805a" stroke="#9a5a3e" strokeWidth="2" />
          <rect x="204" y="156" width="36" height="6" rx="2" fill="#b9704a" stroke="#9a5a3e" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'butterfly', label: 'butterfly', at: [158, 130], box: [138, 112, 40, 36], art: (
        <g>
          <ellipse cx="150" cy="124" rx="8" ry="9" fill="#e0b34a" stroke="#b88f30" strokeWidth="2" />
          <ellipse cx="166" cy="124" rx="8" ry="9" fill="#e0b34a" stroke="#b88f30" strokeWidth="2" />
          <ellipse cx="151" cy="138" rx="6" ry="6" fill="#e0b34a" stroke="#b88f30" strokeWidth="2" />
          <ellipse cx="165" cy="138" rx="6" ry="6" fill="#e0b34a" stroke="#b88f30" strokeWidth="2" />
          <rect x="156" y="118" width="4" height="26" rx="2" fill="#4a4a4a" />
          <path d="M157 118 L152 112 M159 118 L164 112" stroke="#4a4a4a" strokeWidth="1.5" />
        </g>
      ),
    },
    {
      id: 'can', label: 'watering can', at: [164, 250], box: [126, 226, 70, 44], art: (
        <g>
          <rect x="146" y="240" width="34" height="26" rx="4" fill="#5c9a8a" stroke="#3f7a6a" strokeWidth="2" />
          <path d="M146 248 L130 234" stroke="#3f7a6a" strokeWidth="5" strokeLinecap="round" />
          <rect x="125" y="228" width="10" height="8" rx="2" fill="#3f7a6a" transform="rotate(-40 130 232)" />
          <path d="M152 240 Q164 226 176 240" fill="none" stroke="#3f7a6a" strokeWidth="4" />
          <path d="M180 246 Q190 250 180 260" fill="none" stroke="#3f7a6a" strokeWidth="4" />
        </g>
      ),
    },
    {
      id: 'wheelbarrow', label: 'wheelbarrow', at: [284, 238], box: [230, 210, 108, 58], art: (
        <g>
          <path d="M256 222 L326 222 L314 248 L266 248 Z" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <path d="M266 248 L236 236" stroke="#7a5a3e" strokeWidth="4" strokeLinecap="round" />
          <path d="M306 248 L314 262 M282 248 L280 262" stroke="#7a5a3e" strokeWidth="4" strokeLinecap="round" />
          <circle cx="314" cy="256" r="9" fill="#4a4a4a" stroke="#2e2e2e" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'worm', label: 'worm', at: [362, 280], box: [336, 264, 52, 30], art: (
        <g>
          <path d="M344 284 Q350 272 358 282 Q366 292 374 280 Q378 274 382 278" fill="none" stroke="#d8908a" strokeWidth="6" strokeLinecap="round" />
          <circle cx="381" cy="277" r="1.2" fill="#3a3a3a" />
        </g>
      ),
    },
    {
      id: 'snail', label: 'snail', at: [64, 272], box: [40, 254, 52, 34], art: (
        <g>
          <path d="M46 282 L84 282 Q88 282 86 276 L82 270" fill="#c9b48f" stroke="#9a8a6a" strokeWidth="2" />
          <path d="M82 270 L84 260 M82 270 L88 262" stroke="#9a8a6a" strokeWidth="2" strokeLinecap="round" />
          <circle cx="64" cy="270" r="12" fill="#c9805a" stroke="#9a5a3e" strokeWidth="2" />
          <path d="M64 270 Q68 266 66 262 Q58 262 58 270 Q58 278 66 278 Q74 276 74 268" fill="none" stroke="#9a5a3e" strokeWidth="2" />
        </g>
      ),
    },
  ],
};

const street: Scene = {
  id: 'street',
  label: 'Street',
  kind: 'place',
  w: 400,
  h: 300,
  base: (
    <>
      <rect width="400" height="180" fill="#e3eef5" />
      <rect x="140" y="90" width="150" height="90" fill="#e2d6c6" stroke="#c9bba8" strokeWidth="2" />
      <rect x="290" y="70" width="110" height="110" fill="#d6dcd0" stroke="#bcc4b4" strokeWidth="2" />
      <g fill="#eef2f5" stroke="#c9bba8" strokeWidth="1.5">
        {[300, 336, 372].map((x) => <rect key={x} x={x} y="86" width="20" height="24" />)}
      </g>
      <rect y="180" width="400" height="34" fill="#d9d4cc" />
      <rect y="214" width="400" height="86" fill="#9ca3aa" />
      <rect y="212" width="400" height="4" fill="#8a8f96" />
      <g fill="#e8e8e0">{[20, 70, 120, 170, 220].map((x) => <rect key={x} x={x} y="290" width="28" height="3" />)}</g>
    </>
  ),
  parts: [
    {
      id: 'shop', label: 'shop', at: [70, 120], box: [6, 44, 128, 140], art: (
        <g>
          <rect x="12" y="50" width="116" height="130" fill="#e8dcc6" stroke="#b98a5c" strokeWidth="3" />
          <path d="M8 84 L132 84 L126 104 L14 104 Z" fill="#d98a7a" stroke="#b0685a" strokeWidth="2" />
          <g fill="#f4ece0">{[30, 54, 78, 102].map((x) => <rect key={x} x={x} y="85" width="10" height="18" />)}</g>
          <rect x="20" y="60" width="100" height="18" fill="#c9b48f" />
          <rect x="22" y="114" width="56" height="44" fill="#cfe8f7" stroke="#b98a5c" strokeWidth="3" />
          <rect x="88" y="114" width="30" height="66" fill="#9a7452" stroke="#7a5a3e" strokeWidth="2" />
          <circle cx="112" cy="148" r="2.5" fill="#e0b34a" />
          <circle cx="36" cy="150" r="5" fill="#d8473b" />
          <circle cx="50" cy="150" r="5" fill="#f2c230" />
          <circle cx="64" cy="150" r="5" fill="#3f9a45" />
        </g>
      ),
    },
    {
      id: 'busstop', label: 'bus stop', at: [176, 156], box: [144, 104, 64, 104], art: (
        <g>
          <rect x="150" y="124" width="52" height="6" fill="#5c6670" />
          <rect x="152" y="130" width="4" height="74" fill="#5c6670" />
          <rect x="196" y="130" width="4" height="74" fill="#5c6670" />
          <rect x="156" y="132" width="40" height="48" fill="#cfe8f7" opacity="0.7" stroke="#8a96a3" strokeWidth="1.5" />
          <rect x="160" y="184" width="32" height="5" fill="#8a96a3" />
          <line x1="176" y1="124" x2="176" y2="108" stroke="#5c6670" strokeWidth="3" />
          <circle cx="176" cy="112" r="8" fill="#2f74c8" stroke="#22558f" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'lamp', label: 'lamp post', at: [226, 134], box: [210, 58, 32, 150], art: (
        <g>
          <rect x="223" y="78" width="6" height="124" fill="#4a5560" />
          <rect x="218" y="200" width="16" height="6" rx="2" fill="#4a5560" />
          <path d="M216 80 L236 80 L232 64 L220 64 Z" fill="#f2df9a" stroke="#4a5560" strokeWidth="2" />
        </g>
      ),
    },
    {
      id: 'postbox', label: 'post box', at: [262, 184], box: [246, 156, 36, 52], art: (
        <g>
          <path d="M252 204 L252 172 Q252 162 263 162 Q274 162 274 172 L274 204 Z" fill="#c0443a" stroke="#8a2f28" strokeWidth="2" />
          <rect x="256" y="176" width="14" height="3" fill="#4a2a24" />
          <rect x="250" y="200" width="26" height="6" fill="#4a4a4a" />
        </g>
      ),
    },
    {
      id: 'bin', label: 'bin', at: [306, 190], box: [290, 166, 34, 44], art: (
        <g>
          <rect x="296" y="176" width="22" height="30" rx="3" fill="#7fa08a" stroke="#5c7a66" strokeWidth="2" />
          <rect x="293" y="170" width="28" height="7" rx="2" fill="#5c7a66" />
        </g>
      ),
    },
    {
      id: 'lights', label: 'traffic light', at: [372, 150], box: [352, 98, 40, 112], art: (
        <g>
          <rect x="369" y="150" width="6" height="56" fill="#4a4a4a" />
          <rect x="360" y="104" width="24" height="52" rx="4" fill="#3a3a3a" />
          <circle cx="372" cy="116" r="6" fill="#c0443a" />
          <circle cx="372" cy="130" r="6" fill="#7a6a3a" />
          <circle cx="372" cy="144" r="6" fill="#3f5a3f" />
        </g>
      ),
    },
    {
      id: 'crossing', label: 'zebra crossing', at: [322, 256], box: [282, 216, 80, 82], art: (
        <g fill="#f4f1e8">
          {[220, 236, 252, 268, 284].map((y) => <rect key={y} x="288" y={y} width="68" height="9" />)}
        </g>
      ),
    },
    {
      id: 'car', label: 'car', at: [78, 256], box: [20, 226, 116, 62], art: (
        <g>
          <path d="M28 266 L32 250 L54 246 L68 230 L106 230 L118 246 L128 250 L128 270 L28 270 Z" fill="#7fa0c0" stroke="#41607a" strokeWidth="2" />
          <path d="M72 234 L86 234 L86 246 L60 246 Z" fill="#cfe8f7" />
          <path d="M90 234 L104 234 L112 246 L90 246 Z" fill="#cfe8f7" />
          <circle cx="52" cy="272" r="11" fill="#4a4a4a" stroke="#2e2e2e" strokeWidth="2" />
          <circle cx="108" cy="272" r="11" fill="#4a4a4a" stroke="#2e2e2e" strokeWidth="2" />
          <circle cx="52" cy="272" r="4" fill="#c9cdd2" />
          <circle cx="108" cy="272" r="4" fill="#c9cdd2" />
        </g>
      ),
    },
    {
      id: 'bicycle', label: 'bicycle', at: [204, 260], box: [160, 232, 90, 56], art: (
        <g fill="none" stroke="#3f7a3f" strokeWidth="3" strokeLinecap="round">
          <circle cx="178" cy="268" r="14" stroke="#4a4a4a" />
          <circle cx="230" cy="268" r="14" stroke="#4a4a4a" />
          <path d="M178 268 L196 246 L222 246 L230 268 M196 246 L206 268 L222 246 M206 268 L178 268" />
          <path d="M192 240 L200 240 M222 246 L218 236 L226 234" />
        </g>
      ),
    },
    {
      id: 'sun', label: 'sun', at: [214, 34], box: [188, 8, 52, 52], art: (
        <circle cx="214" cy="34" r="20" fill="#f2d27a" stroke="#d9b354" strokeWidth="2" />
      ),
    },
    {
      id: 'cloud', label: 'cloud', at: [326, 34], box: [286, 14, 80, 40], art: (
        <path d="M296 48 Q288 36 302 32 Q306 20 322 24 Q332 16 344 26 Q360 26 356 40 Q360 50 346 50 L304 50 Q294 50 296 48 Z" fill="#ffffff" stroke="#c9d6df" strokeWidth="2" />
      ),
    },
  ],
};

export const OUTDOORS: Scene[] = [park, playground, beach, farm, garden, street];
